import { render } from "./GolfDashboard.vue?vue&type=template&id=5e691e12&scoped=true"
import script from "./GolfDashboard.vue?vue&type=script&lang=js"
export * from "./GolfDashboard.vue?vue&type=script&lang=js"

import "./GolfDashboard.vue?vue&type=style&index=0&id=5e691e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e691e12"]])

export default __exports__